import React, { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Search } from "lucide-react";
import SearchDropdown from "./SearchDropdown";

/**
 * Mobile-only trigger that opens SearchDropdown inside a dialog.
 * The dropdown already handles navigation + closing, so we just mirror its state.
 */
export default function MobileSearchTrigger() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="md:hidden p-2 rounded-md hover:bg-black/5"
        data-testid="header-mobile-search"
        aria-label="Open search"
      >
        <Search className="w-4 h-4 text-[#3A3B3E]" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md p-5 border border-[#E2DDD3]" style={{ background: "#F7F4EE" }} data-testid="mobile-search-dialog">
          <div className="ns-eyebrow mb-2" style={{ fontSize: 11 }}>Search Nivesh Street</div>
          <SearchDropdown />
          <p className="text-[11px] text-[#8C8D90] mt-3">Press Enter to open all results.</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
